import { Space, Typography, type UploadFile } from 'antd';
import { type ReactNode } from 'react';
import styled from 'styled-components';

const FileNameStyledSpace = styled(Space)`
  padding-right: 8px;
  .ant-typography,
  .anticon {
    font-size: 16px;
  }
`;

const UploadedFileRowWrapper = styled.div`
  margin-top: -2px;
  padding-top: 6px;
  padding-left: 8px;
  border-left: 4px solid ${props => props.theme.colorBorderSecondary};
  padding-bottom: 2px;
  & + & {
    padding-top: 8px;
  }
`;

export interface IFileRowProps {
  file: UploadFile;
  icon: ReactNode;
  downloadButton?: ReactNode;
  deleteButton?: ReactNode;
  readonly?: boolean;
}

/**
 * Riga che contiene i dati di un file caricato. Simula la fileList dell'upload di antd.
 */
export function FileRow(props: IFileRowProps) {
  const { icon, file, downloadButton, deleteButton, readonly } = props;
  return (
    <UploadedFileRowWrapper>
      <div>
        <Space>
          <FileNameStyledSpace size={4} align="baseline">
            {icon}
            <Typography.Text
              type={file.status === 'error' ? 'danger' : undefined}
            >
              {file.name}
            </Typography.Text>
          </FileNameStyledSpace>
          {file.status !== 'error' && downloadButton}

          {!readonly && deleteButton}
        </Space>
      </div>
    </UploadedFileRowWrapper>
  );
}
